import React from "react";
import { siteData } from "../data/mock";
import { CheckCircle2, ArrowRight } from "lucide-react";

const Programme = () => {
  const { programme } = siteData;
  return (
    <section id="programme" className="py-16 sm:py-20 lg:py-32 relative overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(700px 400px at 80% 40%, rgba(70,50,140,0.14), transparent 60%)",
        }}
      />
      <div className="max-w-[1280px] mx-auto px-5 sm:px-6 lg:px-10 relative">
        <div className="max-w-[860px] mx-auto text-center">
          <div className="flex items-center justify-center gap-3">
            <span className="eyebrow-line" />
            <span className="text-[11px] tracking-[0.32em] uppercase text-[#5EC7F5]">
              {programme.eyebrow}
            </span>
            <span className="eyebrow-line" />
          </div>
          <h2 className="font-display text-[32px] sm:text-[44px] md:text-[52px] lg:text-[60px] leading-[1.02] sm:leading-[0.98] mt-6 text-gradient-title uppercase">
            {programme.title}
          </h2>
          <p className="font-italic-serif text-[20px] sm:text-[26px] md:text-[32px] lg:text-[36px] mt-2 text-gradient-blue">
            {programme.italic}
          </p>
          <p className="text-slate-400 text-[14px] sm:text-[15px] mt-6 max-w-[640px] mx-auto">
            {programme.intro}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-3 sm:gap-4 max-w-[760px] mx-auto mt-10 sm:mt-12">
          {programme.features.map((f) => (
            <div
              key={f}
              className="flex items-center gap-3 px-4 sm:px-5 py-3.5 sm:py-4 rounded-xl border hairline bg-[#0b1220]/60 hover:border-[#5EC7F5]/25 transition-colors"
            >
              <CheckCircle2 className="w-4 h-4 text-[#5EC7F5] shrink-0" />
              <span className="text-[13.5px] sm:text-[14px] text-slate-300">{f}</span>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-10 sm:mt-12">
          <a
            href="#register"
            className="inline-flex items-center gap-2 px-6 sm:px-7 py-3.5 rounded-full bg-[#5EC7F5] text-[#062026] font-semibold text-[13px] sm:text-sm glow-blue-btn hover:bg-[#5EC7F5] transition-colors"
          >
            {programme.cta} <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Programme;
